export default __webpack_public_path__ + "static/media/H0005.18564a64.png";